import React from 'react';

import { Box } from '@wds/box';
import { Package } from '~pricing/components/Summary';

import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import SummaryFooter from '~pricing/components/PricingFooter';
import { Packages } from '~shared/constants/pricing';
import useSummaryStyles from './useStyles';
import { usePackages } from '~shared/hooks/usePackages';

export default function PricingSummaryPage(): JSX.Element {
  const { PackagesContainer, Summary } = useSummaryStyles();
  const { displayPackages, allPackages, comparePlans } = usePackages();

  const filteredPackages = displayPackages.filter(pkg => pkg?.packageName !== Packages.Basic);

  return (
    <div key="PricingSummary">
      <header>
        <MainHeading />
        <Navigation />
      </header>
      <Box className={Summary}>
        <Box className={PackagesContainer}>
          {filteredPackages?.map(
            (pricingPackage, index: number) =>
              pricingPackage && (
                <Package
                  {...pricingPackage}
                  // TODO: this is a bit of a hack for TS right now.
                  // it'll be addressed properly in GROW-2118
                  comparisonSkuCost={pricingPackage.comparisonSkuCost || []}
                  comparePlans={comparePlans}
                  key={`package-${pricingPackage.packageName}`}
                  isLastPackage={index + 1 === filteredPackages.length}
                />
              )
          )}
        </Box>
        <SummaryFooter packages={allPackages} />
      </Box>
    </div>
  );
}
